export const GET_BOOKS = "GET_BOOKS";
export const CLEAN_CACHE = "CLEAN_CACHE";
export const GET_BOOK_DETAILS = "GET_BOOK_DETAILS";
export const LOCAL_HOST = "https://oasis-api.facudev.xyz";
export const ALPHABETICAL_SORT = "ALPHABETICAL_SORT";
export const SCORE_SORT = "SCORE_SORT";
export const PRICE_SORT = "PRICE_SORT";
export const GENRE_FILTER = "GENRE_FILTER";
export const GET_AUTHORS = "GET_AUTHORS";
export const GET_GENRES = "GET_GENRES";
export const POST_BOOK = "POST_BOOK";
export const SAGA_FILTER = "SAGA_FILTER";
export const GET_NAME_BOOKS = "GET_NAME_BOOKS";
export const LANGUAGE_FILTER = "LANGUAGE_FILTER";
export const AUTHOR_FILTER = "AUTHOR_FILTER";
export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_FAVS = "ADD_FAVS";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const REMOVE_FROM_FAVS = "REMOVE_FROM_FAVS";
export const GET_AUTHOR_DETAILS = "GET_AUTHOR_DETAILS";
// export const GET_AUTHOR_DETAILS_NAME = "GET_AUTHOR_DETAILS_NAME";
export const GET_AUTHOR_BOOKS = "GET_AUTHOR_BOOKS";
export const CHECKOUT_CART = "CHECKOUT_CART";
// export const CLEAN_CACHE_AUTHOR = "CLEAN_CACHE_AUTHOR";
export const GET_USERS = "GET_USERS";
export const UPDATE_USERS = "UPDATE_USERS";
export const UPDATE_BOOK_STOCK = "UPDATE_BOOK_STOCK";
export const POST_REVIEW = "POST_REVIEW";
export const GET_CART = "GET_CART";
export const UPDATE_BOOK_STOCK_SUCCESS = "UPDATE_BOOK_STOCK_SUCCESS";
export const CLEAR_CART = "CLEAR_CART";
export const BOOK_FULL_UPDATE = "BOOK_FULL_UPDATE";
export const UPDATE_BOOK = "UPDATE_BOOK";
export const GET_REVIEW = "GET_REVIEW";
export const GET_ORDER = "GET_ORDER";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const ACTIVE_ACCOUNT = "ACTIVE_ACCOUNT";
export const DISABLE_ACCOUNT = "DISABLE_ACCOUNT";
export const MAKE_ADMIN = "MAKE_ADMIN";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const GET_FAVS = "GET_FAVS";
export const DELETE_BOOK = "DELETE_BOOK";
